import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

/**
 * There is no program-instances LIST surface — only the per-instance show
 * child route. Without this redirect the bare URL renders a permanently
 * empty outlet (Ember auto-generates the parent index), so send visitors to
 * the TA dashboard.
 */
export default class AuthenticatedAdminTuitionAssistanceProgramInstancesIndexRoute extends Route {
  @service declare router: RouterService;

  redirect() {
    this.router.replaceWith('authenticated.admin.tuition-assistance.dashboard');
  }
}
